// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_TimelineResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/receita/timeline?bucket={day|week|month}
 *
 * Dual-series cash-flow timeline scoped by the user's session filter.
 *
 *   - registrada (recebimento_data)         — when payment was recorded
 *   - disponivel (recebimento_data_disponivel) — when funds become usable
 *   - pendente (compromisso "a receber")     — booked but not yet paid
 *
 * The two date semantics are NEVER collapsed — they go in separate
 * fields of each bucket so the FE can render them on a dual axis.
 *
 * `bucket` echoes the requested granularity for FE re-rendering.
 */
import type { Receita_TimelineBucketRow } from './Receita_TimelineBucketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Receita_TimelineResponseDados {
bucket: string
items: Receita_TimelineBucketRow[]
}

export type Receita_TimelineResponse = ApiResponse<Receita_TimelineResponseDados>;

registerResponseContract('Receita_TimelineResponse', {
  bucket: { type: 'string',  required: true },
  items: {
    type: 'array',
    required: true,
    items: {
      bucket:     { type: 'string',  required: false },
      registrado: { type: 'number',  required: false },
      disponivel: { type: 'number',  required: false },
      pendente:   { type: 'number',  required: false },
    },
  },
})
